import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize i18n before rendering
import './i18n';
import ErrorBoundary from './components/ErrorBoundary';

const rootEl = document.getElementById('root');
if (!rootEl) {
  document.body.innerHTML =
    '<p style="padding:24px;font-family:system-ui">Fehler: Element #root fehlt.</p>';
} else {
  createRoot(rootEl).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

// Agents erst nach Mount laden — verhindert, dass ein Fehler in der Agent-/MCP-Importkette
// die komplette App blockiert (leeres #root auf Production).
void import('./ai/init')
  .then(({ initializeAgents }) => {
    try {
      initializeAgents();
    } catch (e) {
      console.error('initializeAgents failed:', e);
    }
  })
  .catch((e) => {
    console.error('AI agents module failed to load:', e);
  });
